import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

export function LinkedInOriginalIcon(props: PropsType) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.333008 2.00447C0.333008 1.08133 1.10584 0.332031 2.05852 0.332031H21.9548C22.9079 0.332031 23.6803 1.08133 23.6803 2.00447V22.0072C23.6803 22.9306 22.9079 23.6794 21.9548 23.6794H2.05852C1.10593 23.6794 0.333008 22.9307 0.333008 22.0075V2.00419V2.00447Z"
        fill="#006699"
      />
      <path
        d="M7.42816 19.8709V9.35989H3.93445V19.8709H7.42852H7.42816ZM5.68203 7.92503C6.9001 7.92503 7.65844 7.1179 7.65844 6.10923C7.63564 5.07757 6.9001 4.29297 5.7052 4.29297C4.50947 4.29297 3.72852 5.07757 3.72852 6.10914C3.72852 7.11781 4.48657 7.92494 5.65914 7.92494H5.68176L5.68203 7.92503ZM9.36197 19.8709H12.8554V14.0017C12.8554 13.688 12.8782 13.3734 12.9705 13.1494C13.2229 12.5214 13.7978 11.8715 14.7631 11.8715C16.027 11.8715 16.5329 12.8353 16.5329 14.2484V19.8709H20.0262V13.8442C20.0262 10.6158 18.3029 9.11346 16.0044 9.11346C14.1199 9.11346 13.2923 10.1667 12.8324 10.8841H12.8557V9.36025H9.36215C9.40775 10.3463 9.36188 19.8713 9.36188 19.8713L9.36197 19.8709Z"
        fill="white"
      />
    </svg>
  );
}
